import i18n from 'i18n-literally'

import * as constants from './utils/constants'

export * from './shapes'
export * from './utils'
export const SPLIT_GRAPH_OPTIONS = [
  {
    get label() {
      return i18n`Default`
    },
    value: constants.ROOM_GRAPH_SINGLE,
  },
  // { label: 'Individual zone graphs', value: constants.INDIVIDUAL_ZONE_GRAPHS },
  {
    get label() {
      return i18n`Split: Environment / Substrate`
    },
    value: constants.ENVIRONMENT_AND_SUBSTRATE_SPLIT,
  },
  // { label: 'Sensor values/ Dryback', value: constants.SENSOR_AND_DRYBACK_SPLIT },
  // { label: 'Daily Plant growth / Dryback', value: constants.PLANT_GROWTH_AND_DRYBACK_SPLIT }
]
